import { writable } from 'svelte/store';

import { db } from '../firestore';
import { currentTenant } from '../stores/tenant.js';

function getInitials(name) {
    var parts = name.split(' ');
    var initials = '';
    for (var i = 0; i < parts.length; i++) {
        if (parts[i].length > 0 && parts[i] !== '') {
            initials += parts[i][0]
        }
    }
    return initials.substring(0, 3);
}

function createUserStore() {
	const { subscribe, set, update } = writable(null);
    return {
		subscribe,
		setViaAuthUser: async (authUser, userDoc) => {
            console.log('Start of currentUser.setViaAuthUser:', authUser);
            if(authUser == null)
                return;
            // Load user profile from Firebase
           // let userDoc = await db.collection('users').doc(authUser.uid).get();
            // let userProfile = await userDoc.data();
            // return db.collection("users").doc(authUser.uid)
            //     .onSnapshot((doc) => {
            //         set({
            //             uid: authUser.uid,
            //             displayName: doc.displayName,
            //             initials: doc.initials,
            //             email: doc.email,
            //             photoURL: doc.photoURL,
            //             tenantIds: doc.tenantIds,
            //             auth: authUser
            //             // profile: userProfile
            //         });

            //     if(doc.tenantIds == null)
            //             return;
            //      currentTenant.setViaTid(doc.tenantIds[0]);
            // }, function(error) {
            //    console.log(error);
            // });
            // console.log('userProfile')

            // console.log(userProfile)
            console.log('authUser');
            if(userDoc == null){
                console.log('No user doc available');
                await currentTenant.setViaTid(null);
                return;
            }
            console.log(authUser);
            set({
                uid: authUser.uid,
                displayName: userDoc.displayName,
                initials: userDoc.initials,
                email: userDoc.email,
                photoURL: authUser.photoURL, // just temporary until AccountDropDown & UserStore are refactored
                tenantIds: userDoc.tenantIds,
                auth: authUser
                // profile: userProfile
            });

            // Set the default tenant (right now, just set the first of the user's tenants)
           //await currentTenant.setViaTid(Object.entries(userProfile.teams)[0][0]);
           await currentTenant.setViaTid(userDoc.tenantIds[0]);
        },
		reset: () => {
            // Reset itself (the curentUser)
            set(undefined);
            // Reset currentTenant
            currentTenant.reset();
        }
	};
}

export const currentUser = createUserStore();

// export const currentUser = writable(null);